import { EEmployeePageType } from "../screens/employee/constant";
import { EEmployeeRole, EmployeeProperties } from "../types/employee.type";

export const renderEmployeeCodeOrTemp = (employee?: EmployeeProperties) => {
	if (!employee) return;

	if (employee.employeeCode) return employee.employeeCode.toUpperCase();

	if (employee.tempEmployeeCode) return employee.tempEmployeeCode.toUpperCase();

	return;
};

/**
 * This helper for getting return from
 * employee screen
 **/
export const getFilterMainRole = (type: string) => {
	switch (type) {
		case "hq":
			return [
				"admin",
				"admin_general_manager",
				"admin_manager",
				"admin_hq",
				"admin_finance_gm",
				"admin_finance_manager",
				"admin_finance_staff",
			].join(",");

		case "author":
			return ["admin_blog"].join(",");

		case "franchise-owner":
			return "franchise_owner";

		case "agent":
			return "agent";

		case "office-personnel":
			return "business_owner,manager_office,finance_office,admin_office";

		case "staff":
			return "business_owner,manager_office,finance_office,admin_office";

		default:
			return "";
	}
};

export const getFilterMainRoleDetail = (type: string) => {
	switch (type) {
		case "hq":
			return [
				"admin",
				"admin_general_manager",
				"admin_manager",
				"admin_hq",
				"admin_finance_gm",
				"admin_finance_manager",
				"admin_finance_staff",
				"admin_blog",
			].join(",");

		case "author":
			return ["admin_blog"].join(",");

		case "franchise-owner":
			return "franchise_owner";

		case "agent":
			return "agent";

		case "office-personnel":
			return "business_owner,manager_office,finance_office,admin_office";

		case "staff":
			return "business_owner,manager_office,finance_office,admin_office";

		default:
			return "";
	}
};
export const getFullType = (type: string) => {
	switch (type) {
		case "hq":
			return "HQ";

		case "franchise-owner":
			return "Franchise Owner";

		case "agent":
			return "Agent";

		case "staff":
			return "Staff";

		case "author":
			return "Author";

		default:
			return "";
	}
};

export const getAllowedRoles = (type: EEmployeePageType) => {
	switch (type) {
		case EEmployeePageType.HQ:
			return [
				EEmployeeRole.admin,
				EEmployeeRole.admin_general_manager,
				EEmployeeRole.admin_manager,
				EEmployeeRole.admin_hq,
				EEmployeeRole.admin_finance_gm,
				EEmployeeRole.admin_finance_manager,
				EEmployeeRole.admin_finance_staff,
			];

		case EEmployeePageType.AUTHOR:
			return [EEmployeeRole.admin_blog];

		case EEmployeePageType.FRANCHISE_OWNER:
			return [EEmployeeRole.franchise_owner];

		case EEmployeePageType.AGENT:
			return [EEmployeeRole.agent];

		case EEmployeePageType.OFFICE_PERSONNEL:
			return [
				EEmployeeRole.business_owner,
				EEmployeeRole.finance_office,
				EEmployeeRole.admin_office,
				EEmployeeRole.manager_office,
			];

		default:
			return [];
	}
};

export function isValidDataStarAgent(employee: EmployeeProperties) {
	return employee.starAgentPhoto &&
		employee.starAgentPhoto.fileUrl &&
		employee.starAgentTitle &&
		employee.starAgentWebContent &&
		employee.starAgentItems &&
		employee.starAgentItems.type
		? true
		: false;
}

export const OFFICE_ROLES = [
	EEmployeeRole.business_owner,
	EEmployeeRole.finance_office,
	EEmployeeRole.admin_office,
	EEmployeeRole.manager_office,
	EEmployeeRole.agent,
];
